// @greenlight-spec: 19-design-system.md
// @greenlight-spec: 28-it-dashboard-ui.md
import { NavLink } from 'react-router-dom';

import { cn } from '@/lib/utils';
import type { NavItem } from '@/lib/nav';

interface SidebarNavProps {
  items: readonly NavItem[];
  variant: 'sidebar' | 'drawer';
  onNavigate?: () => void;
}

export function SidebarNav({ items, variant, onNavigate }: SidebarNavProps) {
  const showLabels = variant === 'drawer' ? 'inline' : 'md:hidden lg:inline';
  return (
    <nav
      aria-label="Primary"
      className="flex flex-col gap-0.5 px-2 py-3"
      data-testid={`nav-${variant}-items`}
    >
      {items.map((item) => {
        const Icon = item.icon;
        return (
          <NavLink
            key={item.to}
            to={item.to}
            onClick={onNavigate}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-2 rounded-md px-3 h-11 md:h-9 text-[13.5px] font-medium transition-colors',
                isActive
                  ? 'bg-accent font-semibold text-foreground ring-1 ring-inset ring-input'
                  : 'text-foreground hover:bg-accent/50',
              )
            }
            aria-label={item.label}
          >
            <Icon className="shrink-0 size-4" aria-hidden />
            <span className={cn(showLabels)}>{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
